// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"6ad315c34d780021155d","731":"9a1e28a4e363890f5c7b","843":"04009c3e6ac03dae371f","883":"07dce695cb8258097793"}[chunkId] + ".js";
};